import { render, staticRenderFns } from "./email-template-preview-dialog.vue?vue&type=template&id=4b9608d8"
import script from "./email-template-preview-dialog.vue?vue&type=script&lang=js"
export * from "./email-template-preview-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports